// @flow
import { call, put, takeLatest } from 'redux-saga/effects';
import { changePassword, passwordResetEmail, resetPassword as resetPasswordApi } from '~/core/api';
import type { ChangePasswordAction, PasswordResetRequestAction, SendPasswordResetEmailSaga } from './types';
import { FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST, PASSWORD_RESET_REQUEST, RESETTING_PASSWORD } from './constants';
import { passwordEmailRequestSent, resetPassword } from './actions';
import { alerts } from '~/core/constants';
import { compose, noop } from 'lodash/fp';
import handleApi from '~/core/state/handle-api';
import handleSaga from '~/core/state/handle-saga';
import type { Effect } from 'redux-saga';
import messages from './intl';
import { requestAlert } from '~/core/state/alerts/actions';
import { resetPassword as resetPasswordErrors } from '~/core/constants/errors';

export function* changePasswordSaga({ payload }: ChangePasswordAction): Generator<Effect, *, *> {
    const putAction = compose(put, resetPassword);

    const [, err] = yield call(
        handleApi(changePassword),
        payload.newPassword,
        payload.existingPassword,
        payload.userId
    );

    if (err) {
        if (messages[err.status]) {
            yield put(requestAlert(messages[err.status], alerts.types.ERROR));
        }
        return yield putAction(err);
    }

    yield putAction(true);
}

export function* sendPasswordResetEmailSaga({ payload }: SendPasswordResetEmailSaga): Generator<noop | Effect, *, *> {
    const [json, err] = yield call(handleApi(passwordResetEmail), payload);
    yield put(passwordEmailRequestSent(err || json));
}

export function* passwordResetRequestSaga({
    payload: { password, token, email }
}: PasswordResetRequestAction): Generator<Effect, *, *> {
    const [json, error] = yield call(handleApi(resetPasswordApi), password, token, email);
    if (error) {
        const errorMsg = resetPasswordErrors[error.status] || resetPasswordErrors.DEFAULT_ERROR_MSG;
        yield put(requestAlert(errorMsg, alerts.types.ERROR));
    }
    yield put(resetPassword(error || json));
}

function* watchChangePasswordSaga(): Generator<Effect, *, *> {
    yield takeLatest(RESETTING_PASSWORD, handleSaga(changePasswordSaga));
}

function* watchSendPasswordResetEmailSaga(): Generator<Effect, *, *> {
    yield takeLatest(FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST, handleSaga(sendPasswordResetEmailSaga));
}

function* watchPasswordResetRequest(): Generator<Effect, *, *> {
    yield takeLatest(PASSWORD_RESET_REQUEST, handleSaga(passwordResetRequestSaga));
}

export default [watchChangePasswordSaga, watchSendPasswordResetEmailSaga, watchPasswordResetRequest];



// WEBPACK FOOTER //
// ./src/core/state/authentication/sagas.js